var bridgeState = {
  autoplayEnabled: false,
  debugModeEnabled: false,
  compactViewModeEnabled: false
};

var SRFLegacyBridge = {
  init: init,
  isReady: isReady,
  isRunningInLegacyApp: isRunningInLegacyApp,
  sendEvent: sendEvent,
  isAutoplayEnabled: isAutoplayEnabled
};
/**
 * @returns true if we are running in a legacy app.
 */

function isRunningInLegacyApp() {
  return typeof window.nativebridge !== 'undefined';
}
/**
 * @returns true if a legacy app is connected and is ready to receive events.
 */


function isReady() {
  return isRunningInLegacyApp() && window.legacyAppReady === true;
}

function init() {
  waitForLegacyApp(function () {
    sendAllQueuedEvents();
    notifyConnectListeners();
    checkAutoplayPeriodically();
    sendDeviceInfo();
  });
}

function sendEvent(event) {
  var _window$nativebridge, _window$nativebridge2;

  switch (event.eventType) {
    case 'PageMetaData':
      (_window$nativebridge = window.nativebridge) == null ? void 0 : _window$nativebridge.onMetadataRetrieved(JSON.stringify(event.payload));
      break;

    case 'TrackingEvent':
      (_window$nativebridge2 = window.nativebridge) == null ? void 0 : _window$nativebridge2.trackEvent(JSON.stringify(event.payload));
      break;

    case 'PlayVideo':
    case 'PlayAudio':
    case 'PlayLivestream':
    case 'OpenArticle':
    case 'OpenLandingPage':
    case 'OpenLink':
      window.open(event.payload.url);
      break;
  }
}

function isAutoplayEnabled() {
  var _window$legacyAutopla;

  return (_window$legacyAutopla = window.legacyAutoplayEnabled) != null ? _window$legacyAutopla : false;
}

function waitForLegacyApp(callback) {
  if (isReady()) {
    callback();
    return;
  } // clearInterval seems not always to work correctly on some iOS
  // devices. We therefore keep track of it ourselves, to only call the
  // callback function once.


  var intervalCleared = false;
  var waitDelay = 500;
  var waitCount = 30;

  try {
    var intervalID = window.setInterval(function () {
      waitCount--;

      if (isReady() && !intervalCleared) {
        window.clearInterval(intervalID);
        intervalCleared = true;
        callback();
      } else if (waitCount === 0) {
        // No legacy app connected after 1s => we assume it won't happen and stop waiting.
        window.clearInterval(intervalID);
      }
    }, waitDelay);
  } catch (e) {// Ignore
  }
} // Legacy iOS apps return a promise when nativebridge.isAutoplayEnabled() is called.
// To make it easier for library users, we check this setting periodically and
// return the current value of it in isAutoplayEnabled() directly.


function checkAutoplayPeriodically() {
  var _window$nativebridge3;

  if ((_window$nativebridge3 = window.nativebridge) != null && _window$nativebridge3.isAutoplayEnabled) {
    updateAutoplaySetting();
    window.setInterval(updateAutoplaySetting, 5000);
  }
}

function updateAutoplaySetting() {
  var _window$nativebridge4;

  var promise = (_window$nativebridge4 = window.nativebridge) == null ? void 0 : _window$nativebridge4.isAutoplayEnabled == null ? void 0 : _window$nativebridge4.isAutoplayEnabled();
  promise == null ? void 0 : promise.then(function (isEnabled) {
    return window.legacyAutoplayEnabled = isEnabled;
  });
} // After calling fetchMetaData(), the legacy apps will set the device info.
// We convert this data to an OutgoingEvent and send it to the registered listeners.


function sendDeviceInfo() {
  if (window.legacyDeviceInfo) {
    notifyEventListeners({
      eventType: 'DeviceInfo',
      payload: {
        deviceId: window.legacyDeviceInfo.ceid,
        siteName: window.legacyDeviceInfo.navigation_app_site_name
      }
    });
  } else {
    setTimeout(sendDeviceInfo, 100);
  }
}

function log(message, object) {
  if (bridgeState.debugModeEnabled) {
    console.log("[SRFBridge] " + message + " " + stringify(object));
  }
}

function stringify(object) {
  if (object) {
    try {
      return JSON.stringify(object);
    } catch (_unused) {// ignore errors
    }
  }

  return '';
}

var eventQueue = [];
function sendEvent$1(event) {
  if (bridgeState.nativePort) {
    sendEventToApp(event);
  } else if (SRFLegacyBridge.isReady()) {
    SRFLegacyBridge.sendEvent(event);
  } else {
    eventQueue.push(event);
  }
}
function sendAllQueuedEvents() {
  eventQueue.forEach(function (event) {
    return sendEvent$1(event);
  });
  eventQueue = [];
}

function sendEventToApp(event) {
  try {
    var _bridgeState$nativePo;

    log('Sending', event);
    (_bridgeState$nativePo = bridgeState.nativePort) == null ? void 0 : _bridgeState$nativePo.postMessage(JSON.stringify(event));
  } catch (e) {
    log('Failed to send', e);
  }
}

function handleEvent(rawEvent) {
  var _event$payload$autopl, _rawEvent$ports, _window$webkit, _window$webkit$messag, _event$payload$autopl2, _event$payload$isComp;

  var event = parseJSON(rawEvent.data);

  if (event.eventType) {
    log('Received', event);

    switch (event.eventType) {
      case 'Initialize':
        bridgeState.autoplayEnabled = (_event$payload$autopl = event.payload.autoplay) != null ? _event$payload$autopl : false; // Android passes the port when sending the InitializeEvent
        // iOS defines the port globally on the webkit object

        bridgeState.nativePort = ((_rawEvent$ports = rawEvent.ports) == null ? void 0 : _rawEvent$ports[0]) || ((_window$webkit = window.webkit) == null ? void 0 : (_window$webkit$messag = _window$webkit.messageHandlers) == null ? void 0 : _window$webkit$messag.nativePort);
        bridgeState.debugModeEnabled = bridgeState.debugModeEnabled || event.payload.debugMode || false;

        if (event.payload.deviceId) {
          notifyEventListeners({
            eventType: 'DeviceInfo',
            payload: {
              deviceId: event.payload.deviceId,
              siteName: event.payload.appId
            }
          });
        }

        sendAllQueuedEvents();
        notifyConnectListeners();
        break;

      case 'SetAutoplay':
        bridgeState.autoplayEnabled = (_event$payload$autopl2 = event.payload.autoplay) != null ? _event$payload$autopl2 : false;
        break;

      case 'SetViewMode':
        bridgeState.compactViewModeEnabled = (_event$payload$isComp = event.payload.isCompact) != null ? _event$payload$isComp : false;
        break;
    }

    notifyEventListeners(event);
  }
}

function parseJSON(data) {
  try {
    var _JSON$parse;

    return (_JSON$parse = JSON.parse(data)) != null ? _JSON$parse : {};
  } catch (e) {
    // ignore parsing errors and return an empty object
    return {};
  }
}

function registerEventHandler() {
  if (!window.messageListenerRegistered) {
    window.addEventListener('message', handleEvent);
    window.messageListenerRegistered = true;
  }
}
var listeners = {};
function addListener(eventType, listener) {
  if (!listeners[eventType]) {
    listeners[eventType] = [];
  }

  listeners[eventType].push(listener);
}
function notifyEventListeners(event) {
  var _listeners$event$even;

  var listenersToNotify = (_listeners$event$even = listeners[event.eventType]) != null ? _listeners$event$even : [];
  listenersToNotify.forEach(function (listener) {
    return listener(event);
  });
}
var connectListeners = [];
function addConnectListener(listener) {
  connectListeners.push(listener);
  notifyConnectListeners();
}
function notifyConnectListeners() {
  if (bridgeState.nativePort || SRFLegacyBridge.isReady()) {
    connectListeners.forEach(function (listener) {
      try {
        listener();
      } catch (_unused) {// ignore errors in connect listeners
      }
    });
    connectListeners = [];
  }
}

var SRFBridge = {
  /**
   * Initialize the native bridge with the given page metadata.
   * @param pageMetaData the metadata of the current page
   * @param debugMode true if you want to enable debug logging, defaults to false
   */
  init: function init(pageMetaData, debugMode) {
    if (debugMode === void 0) {
      debugMode = false;
    }

    bridgeState.debugModeEnabled = debugMode;
    log('Initializing');
    registerEventHandler();
    initalizeApp();

    sendEvent$1({
      eventType: 'PageMetaData',
      payload: pageMetaData
    });
  },

  /**
   * Register a listener for a bridge event.
   * @param eventType the event name you want to be notified about.
   * @param listener the callback when such an event is received.
   */
  addListener: function addListener$1(eventType, listener) {
    return addListener(eventType, listener);
  },

  /**
   * @returns true if the current page is running in an app.
   */
  isRunningInApp: function isRunningInApp() {
    return !!(window.SRFApp || SRFLegacyBridge.isRunningInLegacyApp());
  },

  /**
   * @returns true if autoplay should be enabled
   */
  isAutoplayEnabled: function isAutoplayEnabled() {
    return bridgeState.autoplayEnabled || SRFLegacyBridge.isAutoplayEnabled();
  },

  /**
   * @returns true if view mode should be compact
   */
  isViewModeCompact: function isViewModeCompact() {
    return bridgeState.compactViewModeEnabled;
  },

  /**
   * Requests the app to play the video with the given URN
   * @param payload a PlayVideoPayload
   */
  playVideo: function playVideo(payload) {
    return sendEvent$1({
      eventType: 'PlayVideo',
      payload: payload
    });
  },

  /**
   * Requests the app to play the audio with the given URN
   * @param payload a PlayAudioPayload
   */
  playAudio: function playAudio(payload) {
    return sendEvent$1({
      eventType: 'PlayAudio',
      payload: payload
    });
  },

  /**
   * Requests the app to play the livestream with the given URN
   * @param payload a PlayLivestreamPayload
   */
  playLivestream: function playLivestream(payload) {
    return sendEvent$1({
      eventType: 'PlayLivestream',
      payload: payload
    });
  },

  /**
   * Information about media playback state between app and web
   * @param playbackState
   * @param urn
   */
  mediaPlaybackStatus: function mediaPlaybackStatus(playbackState, urn) {
    return sendEvent$1({
      eventType: 'MediaPlaybackStatus',
      payload: {
        playbackState: playbackState,
        urn: urn
      }
    });
  },

  /**
   * Informs the app about the current view mode
   * @param isCompact compact state
   */
  informViewMode: function informViewMode(isCompact) {
    return sendEvent$1({
      eventType: 'InformViewMode',
      payload: {
        isCompact: isCompact
      }
    });
  },

  /**
   * Informs the app whether a swipeable collection is visible in the viewport.
   * This is necessary to prevent column swiping in the Android Webviews inside a HorizontalPager.
   * @param swipeableInViewport true if a swipeable collection is visible false otherwise
   */
  updateSwipeableStatus: function updateSwipeableStatus(swipeableInViewport) {
    return sendEvent$1({
      eventType: 'SwipeableStatus',
      payload: {
        swipeableInViewport: swipeableInViewport
      }
    });
  },

  /**
   * Informs the app about the current comment situation
   * @param payload the comment info payload
   */
  sendCommentsInfo: function sendCommentsInfo(payload) {
    return sendEvent$1({
      eventType: 'CommentsInfo',
      payload: payload
    });
  },

  /**
   * Requests the app to open an article
   * @param urn the article URN
   * @param url the URL
   * @param title the article title
   */
  openArticle: function openArticle(urn, url, title) {
    try {
      var typedURL = new URL(url);
      var params = typedURL == null ? void 0 : typedURL.searchParams;
      var anchor = params == null ? void 0 : params.get('anchor');

      if (anchor) {
        sendEvent$1({
          eventType: 'OpenArticle',
          payload: {
            urn: urn,
            url: url,
            title: title,
            anchor: anchor
          }
        });

        return;
      }
    } catch (error) {// no valid URL
    }

    sendEvent$1({
      eventType: 'OpenArticle',
      payload: {
        urn: urn,
        url: url,
        title: title
      }
    });
  },

  /**
   * Requests the app to open a landing page
   * @param urn the landing page URN
   * @param url the URL
   * @param title the landing page title
   */
  openLandingPage: function openLandingPage(urn, url, title) {
    return sendEvent$1({
      eventType: 'OpenLandingPage',
      payload: {
        urn: urn,
        url: url,
        title: title
      }
    });
  },

  /**
   * Requests the app to open an external link
   * @param url the URL
   * @param title the title of the link
   */
  openLink: function openLink(url, title) {
    return sendEvent$1({
      eventType: 'OpenLink',
      payload: {
        url: url,
        title: title
      }
    });
  },

  /**
   * Requests the app to track the given metadata
   * @param payload the metadata payload to track
   */
  trackEvent: function trackEvent(payload) {
    return sendEvent$1({
      eventType: 'TrackingEvent',
      payload: payload
    });
  },

  /**
   * Requests the app to track the given metadata to UDP
   * @param payload the metadata payload to track
   */
  trackUdpEvent: function trackUdpEvent(payload) {
    return sendEvent$1({
      eventType: 'WebToUDPTrackingEvent',
      payload: payload
    });
  },

  /**
   * Requests the app to authenticate the user
   * @param payload client identifier, a scope for authentication
   */
  requestAuthentication: function requestAuthentication(clientId) {
    return sendEvent$1({
      eventType: 'RequestAuthentication',
      payload: {
        clientId: clientId
      }
    });
  },

  /**
   * Requests the app to deauthenticate the user
   * @param clientIds client identifiers for the logout
   */
  requestLogout: function requestLogout(clientIds) {
    return sendEvent$1({
      eventType: 'RequestLogout',
      payload: {
        clientIds: clientIds
      }
    });
  },

  /**
   * Requests the app to open user profile
   */
  openProfile: function openProfile() {
    return sendEvent$1({
      eventType: 'OpenProfile',
      payload: {}
    });
  },

  /**
   * Sends the given event to the app
   * @param event the event to send
   */
  sendEvent: function sendEvent(event) {
    return sendEvent$1(event);
  },

  /**
   * Notifies the given listener when an app has connected.
   * @param listener the listener to notify when the app is ready
   */
  onAppConnected: function onAppConnected(listener) {
    return addConnectListener(listener);
  }
};

function initalizeApp() {
  var _window$SRFApp;

  if ((_window$SRFApp = window.SRFApp) != null && _window$SRFApp.init) {
    // Android provides an init function
    window.SRFApp.init();
  } else if (window.SRFApp) {
    var _window$webkit, _window$webkit$messag, _window$webkit$messag2;

    // iOS expects a message through the native port for initialization
    (_window$webkit = window.webkit) == null ? void 0 : (_window$webkit$messag = _window$webkit.messageHandlers) == null ? void 0 : (_window$webkit$messag2 = _window$webkit$messag.nativePort) == null ? void 0 : _window$webkit$messag2.postMessage(JSON.stringify({
      eventType: 'Ready',
      payload: {}
    }));
  }

  SRFLegacyBridge.init();
}

export { SRFBridge };
//# sourceMappingURL=srf-native-bridge.esm.js.map
